import i18next from 'i18next';
import { toast } from 'sonner';
import { useBcmRpoStore } from '@/store/bcm-rpo.store.js';

export class BcmRpoIntegration {
    constructor(sdkService) {
        this.service = sdkService;
    }

    async fetchAll(params = {}) {
        const store = useBcmRpoStore.getState();
        if (store.setLoading) store.setLoading(true);
        if (store.clearError) store.clearError();
        try {
            const response = await this.service.getAll(params);
            const rows = response.data || [];
            if (store.setItems) store.setItems(rows);
            if (response.pagination && store.setPagination) store.setPagination(response.pagination);
            return { success: true, data: rows };
        } catch (error) {
            const message = error.message || i18next.t('integrationToasts:anErrorOccurred', { defaultValue: 'An error occurred' });
            toast.error(message);
            if (store.setError) store.setError(message);
            return { success: false, error: message, data: [] };
        } finally {
            if (store.setLoading) store.setLoading(false);
        }
    }
}
